import React, { CSSProperties, FC } from 'react';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { ChargeFormEntry } from '../../../../types';
import { MoneyField } from './MoneyField';
import { ChargesFormType } from '../../../../hooks';

interface Props {
  index: number;
  disabled?: boolean;
  name: FieldPath<
    Pick<
      ChargeFormEntry,
      | 'amount'
      | 'amount_calculated'
      | 'amount_override'
      | 'buyer_at'
      | 'buyer_before'
      | 'by_others'
      | 'seller_at'
      | 'seller_before'
      | 'per_month'
      | 'tax'
    >
  >;
  onBlur?: () => void;
  onAmountChange?: (value: number | null) => void;
  borderColor?: CSSProperties['backgroundColor'];
}

export const AmountField: FC<Props> = ({
  index,
  name,
  disabled,
  onBlur,
  onAmountChange,
  borderColor,
}) => {
  const { control } = useFormContext<ChargesFormType>();

  const handleChange = (value: number | null, onFieldChange: (...event: any[]) => void) => {
    onFieldChange(value);
    if (onAmountChange) {
      onAmountChange(value);
    }
  };

  return (
    <Controller
      key={`charges.${index}.${name}`}
      name={`charges.${index}.${name}`}
      control={control}
      render={({ field: { ref, onChange, ...field } }) => (
        <MoneyField
          {...field}
          ref={ref}
          disabled={disabled}
          onChange={(e) => handleChange(e, onChange)}
          name={field.name}
          value={field.value}
          borderColor={borderColor}
        />
      )}
    />
  );
};
